module.exports = __webpack_public_path__ + "1d9da465a539c8b98c60e70cda1bef27.png";